import { useEffect, useState } from "react";
import useLocalStorage from "use-local-storage";
import { ClockFace } from "./components/ClockFace";
import { ClockHistory } from "./components/ClockHistory";
import { ClockHowToRead } from "./components/ClockHowToRead";
import { THEME_MAP } from "./lib/colorThemes";

const HOURS_INDEX = 0;
const MINUTES_INDEX = 1;
const SECONDS_INDEX = 2;

function App() {
  const [timeData, setTimeData] = useState(() => {
    return refreshTime();
  });
  const [persistedTheme, setPersistedTheme] = useLocalStorage(
    "theme",
    "red-yellow"
  ); // holds name of theme to use
  const [showDigitalClock, setShowDigitalClock] = useState(false);
  const [educationalMode, setEducationalMode] = useState(false);
  const [colorTheme, setColorTheme] = useState(THEME_MAP.get("red-yellow")); // holds theme object

  function getColorTheme() {
    if (!THEME_MAP.has(persistedTheme)) {
      setPersistedTheme(colorTheme!.slug);
      return THEME_MAP.get(colorTheme!.slug);
      //return THEME_MAP[colorTheme!.slug as keyof typeof THEME_MAP];
    }
    return persistedTheme !== colorTheme!.slug
      ? THEME_MAP.get(persistedTheme)
      : THEME_MAP.get(colorTheme!.slug);
  }

  useEffect(() => {
    setColorTheme(getColorTheme());
  }, []);

  function toggleShowClock() {
    setShowDigitalClock(!showDigitalClock);
  }

  function toggleEducationalMode() {
    setEducationalMode(!educationalMode);
  }

  function themeChangeHandler(themeName: string) {
    setPersistedTheme(themeName);
    setColorTheme(THEME_MAP.get(themeName));
  }

  useEffect(() => {
    const intervalId = setInterval(() => {
      let tdata = refreshTime();
      setTimeData(tdata);
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  function refreshTime() {
    let now = new Date();
    const elements = [now.getHours(), now.getMinutes(), now.getSeconds()];
    const seconds = Array(1).fill(false);
    const hourRow5 = Array(4).fill(false);
    const hourRow1 = Array(4).fill(false);
    const minuteRow1 = Array(4).fill(false);
    const minuteRow5 = Array(11).fill(false);

    seconds[0] = elements[SECONDS_INDEX] % 2 !== 0;

    let numLights1 = Math.floor(elements[HOURS_INDEX] / 5.0);
    for (let i = 0; i < numLights1; i++) {
      hourRow5[i] = true;
    }

    let numLights2 = elements[HOURS_INDEX] % 5;
    for (let j = 0; j < numLights2; j++) {
      hourRow1[j] = true;
    }

    let numLights3 = Math.floor(elements[MINUTES_INDEX] / 5.0);
    for (let k = 0; k < numLights3; k++) {
      minuteRow5[k] = true;
    }

    let numLights4 = elements[MINUTES_INDEX] % 5;
    for (let x = 0; x < numLights4; x++) {
      minuteRow1[x] = true;
    }

    return {
      timeEls: elements,
      seconds: seconds,
      hourRow5: hourRow5,
      hourRow1: hourRow1,
      minuteRow1: minuteRow1,
      minuteRow5: minuteRow5,
    };
  }

  return (
    <div className="container flex flex-col justify-center mx-auto">
      <div className="p-5 font-medium text-xl text-slate-500 text-center">
        Mengenlehreuhr / Set Theory Clock / Berlin Clock
      </div>
      <div className="text-sm text-slate-500 text-center">
        (currently working on a mobile-friendly version, please use larger
        screens for now)
      </div>
      <div className="flex justify-center p-5">
        <div className="sm:w-4/5 md:w-3/5 lg:w-2/5">
          <ClockFace
            data={timeData}
            eduMode={educationalMode}
            eduModeHandler={toggleEducationalMode}
            showClock={showDigitalClock}
            showClockClickHandler={toggleShowClock}
            theme={colorTheme!}
            themeChangeHandler={themeChangeHandler}
          />
        </div>
      </div>
      {educationalMode ? <ClockHowToRead /> : null}
      {educationalMode ? <ClockHistory /> : null}
      <div className="p-5 text-sm text-slate-500 text-center">
        by John R McWade, 2022
      </div>
    </div>
  );
}

export default App;
